"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getLoginLinkAsync: ()=>getLoginLinkAsync,
    logoutAsync: ()=>logoutAsync,
    redirectToLogin: ()=>redirectToLogin,
    getJwt: ()=>getJwt,
    redirectToSSO: ()=>redirectToSSO,
    fetchJwt: ()=>fetchJwt,
    redirectToLogoutAsync: ()=>redirectToLogoutAsync
});
const external_async_jwt_service_js_namespaceObject = require("./async-jwt.service.js");
const getLoginLinkAsync = function(uniqueKey) {
    let next = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.location.href;
    return external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getService(uniqueKey).then((service)=>service.getLoginLink(next));
};
const redirectToLogoutAsync = (uniqueKey, next)=>external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getService(uniqueKey).then((service)=>service.redirectToLogout(next));
const logoutAsync = (uniqueKey, next)=>external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getService(uniqueKey).then((service)=>service.logout(next));
const redirectToLogin = (uniqueKey)=>external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getService(uniqueKey).then((service)=>service.redirectToLogin());
async function fetchJwt(uniqueKey) {
    return external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getService(uniqueKey).then((service)=>service.fetchJwt());
}
const getJwt = async (uniqueKey)=>external_async_jwt_service_js_namespaceObject.bytecloudAsyncJwtService.getJwt(uniqueKey);
const redirectToSSO = redirectToLogin;
exports.fetchJwt = __webpack_exports__.fetchJwt;
exports.getJwt = __webpack_exports__.getJwt;
exports.getLoginLinkAsync = __webpack_exports__.getLoginLinkAsync;
exports.logoutAsync = __webpack_exports__.logoutAsync;
exports.redirectToLogin = __webpack_exports__.redirectToLogin;
exports.redirectToLogoutAsync = __webpack_exports__.redirectToLogoutAsync;
exports.redirectToSSO = __webpack_exports__.redirectToSSO;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "fetchJwt",
    "getJwt",
    "getLoginLinkAsync",
    "logoutAsync",
    "redirectToLogin",
    "redirectToLogoutAsync",
    "redirectToSSO"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
